// let httpUrl = 'https://localesdsys.issealing.com/';
// let httpUrl = 'https://uatesdsys.issealing.com/';
   let httpUrl = 'https://esdsys.issealing.com/';
export {
    httpUrl,
}